import { getFooterComponent } from "@/src/api/services/component";
import { Footer } from "@/src/components/Footer";

export const FooterFetchWrapper = async () => {
    const footerData = await getFooterComponent();
    if (!footerData) return null;

    return !footerData.hidden ? <Footer {...footerData.props} /> : null;
};
